export default function(value, number) {
  return number > 1 ? value.split(" ").map(v => v + "s").join(" ") : value;
}
